module.exports = __webpack_public_path__ + "img/idCardBack2.613de74a.png";